module.exports = __webpack_public_path__ + "img/right-nav-two.f9676a73.png";